export const SOCKET_IO_OPTIONS = {
	RECONNECTION_DELAY_MAX: 128 * 1000,
	RECONNECTION_DELAY: 200,
	RANDOMIZATION_FACTOR: 0.5,
};
